import React, { useState, useEffect } from "react";
import { message } from "antd";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { findAllDateGroupPaymentsEvent } from '../../../_events/payments/find_payments.event';
import { buildPriceFormat } from '../../../_utils/format_numbers';
import { buildDateTimeStr } from '../../../_utils/date_operations';
import PrimaryProgress from "../../../containers/progress/primary_progress";
import { Divider } from "@mui/material";
const ID_PANEL = 'panel_payment';

const PaymentsInfo = (props) => {

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const findData = () => {
        setLoading(true);
        findAllDateGroupPaymentsEvent()
        .then(data => {
            setData(data.list);
            props.setLastUpdate(data.list.length > 0 ? buildDateTimeStr(data.list[data.list.length - 1].data[data.list[data.list.length - 1].data.length - 1].date_created) : 'Sin datos');
            setLoading(false);
        })
        .catch(err => {
            message.error(err.message);
            setLoading(false);
        });
    };

    const calculateTotalPaid = (data) => {
        let total = 0;
        data.forEach(d => {
            total += Number(d.cop_value);
        });
        return total;
    }

    useEffect(() => {
        findData();
    }, []);   

    if(loading){
        return(
            <PrimaryProgress />
        );
    }
    else{
        return(
            <div style={{height:450, width: '100%' }}>
                {
                    data.map((d, key) => (
                        <Accordion key={`${ID_PANEL}${key}`} >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`${ID_PANEL}${key}bh-content`}
                                id={`${ID_PANEL}${key}bh-header`}
                                >
                                <Typography sx={{ width: '30%', flexShrink: 0 }}>
                                    {d.date}
                                </Typography>
                                <Typography sx={{ width: '30%', flexShrink: 0 }}>
                                    <strong>Total consignado: </strong>{buildPriceFormat(calculateTotalPaid(d.data))}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div style={{width: '100%'}}>
                                    <AccordionInfo data={d.data} />
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    ))
                }
            </div>
        );
    }
}

const AccordionInfo = (props) => {
    return(
        <div>
        {
            props.data.length === 0 ? (
             <>No hay datos</>
            ) : (
            <div style={{width: '100%'}}>
                <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                    <div style={{width: '40%', fontSize:'10px', fontWeight: 'bold'}}>Cliente</div>
                    <div style={{width: '40%', fontSize:'10px', fontWeight: 'bold'}}>Valor</div>
                </div>
                <div style={{width: '100%'}}>
                {
                    props.data.map((d, key) => {
                        return(
                            <div key={key} style={{width: '100%'}}>
                                <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                                    <div style={{width: '40%', fontSize:'10px'}}>{d.client_name}</div>
                                    <div style={{width: '40%', fontSize:'10px'}}>{buildPriceFormat(Number(d.cop_value))}</div>
                                </div>
                                <Divider />
                            </div>
                        )
                    })
                }
                </div>
            </div>
            )
         }
        </div>
    );
}

export default PaymentsInfo;